import type { RouteLocationNormalized } from 'vue-router';

import { useCurrentUserStore } from '@/stores/CurrentUser';

export default async (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
): Promise<void> => {
  const { domainContextIsInitialized, waitForDomainContextInitialization } =
    useCurrentUserStore();

  if (!to?.meta?.requiresDomainContext) {
    return;
  }

  if (domainContextIsInitialized.value) {
    return;
  }

  await waitForDomainContextInitialization();
};
